
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h16v16H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M4.4 15.2c-.33 0-.613-.118-.848-.353A1.156 1.156 0 013.2 14V2c0-.33.117-.613.352-.848S4.07.8 4.4.8h7.2c.33 0 .613.117.848.352.234.235.352.518.352.848v12c0 .33-.118.612-.353.847a1.156 1.156 0 01-.847.353H4.4zm0-3.2h7.2V4H4.4v8z","fill":"#396BDB"}})])])
          )
        }
      }
    